import { render, staticRenderFns } from "./selectDepartment.vue?vue&type=template&id=6f502c22&scoped=true"
import script from "./selectDepartment.vue?vue&type=script&lang=js"
export * from "./selectDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f502c22",
  null
  
)

export default component.exports